import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Simple text-based brand glyphs used in the minimized sidebar gutter.
// Every scope shares the same rendering so the collapsed gutter stays
// visually consistent (flat, muted, no oversized/oversaturated logos).
// Labels: A = Amazon, AMC = AMC, DSP = DSP, G = Google, M = Meta, T = Target, W = Walmart
// NOTE: "M" is currently only used for Meta. Once Microsoft is added, this will
// need to differentiate between the two (e.g. by scope-aware label mapping).
//
// The name bubble is a plain, absolutely-positioned tooltip (no Popper.js)
// so it appears instantly to the right of the gutter with no flicker/reflow.
// The collapsed sidebar already sets `overflow: visible` on its containers,
// so this renders cleanly outside the 55px gutter without being clipped.
export default function GutterBrandIcon({ label, name }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <span
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'default',
      }}
    >
      <span
        style={{
          fontSize: '18px', fontWeight: 600, letterSpacing: '0.5px', color: '#b1c3c8',
        }}
      >
        {label}
      </span>
      <span
        style={{
          position: 'absolute',
          left: 'calc(100% + 10px)',
          top: '50%',
          transform: 'translateY(-50%)',
          whiteSpace: 'nowrap',
          background: '#2f3c47',
          color: '#fff',
          fontSize: '12px',
          fontWeight: 500,
          padding: '4px 10px',
          borderRadius: '4px',
          zIndex: 1000,
          opacity: isHovered ? 1 : 0,
          visibility: isHovered ? 'visible' : 'hidden',
          transition: 'opacity 0.1s linear',
          pointerEvents: 'none',
        }}
      >
        {name}
      </span>
    </span>
  );
}

GutterBrandIcon.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
